<template>
  <div>
    <div class="row">
      <!-- modals -->
      <modal :show.sync="modals" :showClose="false">
        <template slot="header">
          <h5 class="modal-title" id="exampleModalLabel">Schedule Editor</h5>
        </template>
        <div class="row">
          <div class="col-sm-12">
            <base-input
              label="Asset No"
              placeholder="Asset No"
              v-model="assetNo"
              disabled
            ></base-input>
            <base-input label="Asset Desc">
              <textarea
                class="huraian"
                placeholder="Asset Desc"
                v-model="assetDesc"
              ></textarea>
            </base-input>
            <base-input label="Capitalized Date">
              <el-date-picker
                type="date"
                placeholder="Capitalized Date"
                v-model="capitalizedDate"
              ></el-date-picker>
            </base-input>
            <base-input label="Cost Centre">
              <el-select
                class="select-primary tab"
                placeholder="Single Select"
                v-model="costCentre"
              >
                <el-option
                  v-for="option in selects.costcentre"
                  class="select-primary"
                  :value="option.value"
                  :label="option.label"
                  :key="option.label"
                ></el-option>
              </el-select>
            </base-input>
            <base-input label="Owned By">
              <el-select
                class="select-primary tab"
                placeholder="Single Select"
                v-model="ownedBy"
              >
                <el-option
                  v-for="option in selects.ownedby"
                  class="select-primary"
                  :value="option.value"
                  :label="option.label"
                  :key="option.label"
                ></el-option>
              </el-select>
            </base-input>
            <base-input label="Asset Image (in JPG)">
              <image-upload
                @change="onImageChange"
                select-text="Select Image"
                :src="img"
                v-model="image"
              />
            </base-input>
            <div class="d-flex justify-content-center spinner" v-if="load">
              <circle-8></circle-8>
            </div>
          </div>
        </div>
        <div
          class="col-sm-12 d-flex justify-content-between"
          style="margin-top: 1%"
        >
          <base-button type="success" @click="submit()">Submit</base-button>
          <base-button type="warning" @click="modals = false"
            >Cancel</base-button
          >
        </div>
      </modal>

      <div class="col-lg-12 inline">
        <h2 style="display: inline">Asset Management</h2>
      </div>
      <div class="col-lg-12">
        <hr />
      </div>
      <div class="col-md-12">
        <card card-body-classes="table-full-width">
          <div>
            <div class="row">
              <div class="col-lg-8">
                <h4 class="card-title">List of Asset</h4>
              </div>
            </div>
            <div
              class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
            >
              <base-input label="rows visible">
                <el-select
                  class="select-info mb-3 pagination-select"
                  v-model="pagination.perPage"
                  placeholder="Per page"
                >
                  <el-option
                    class="select-primary"
                    v-for="item in pagination.perPageOptions"
                    :key="item"
                    :label="item"
                    :value="item"
                  ></el-option>
                </el-select>
              </base-input>
              <base-input>
                <el-input
                  type="search"
                  class="mb-3 search-input"
                  clearable
                  prefix-icon="el-icon-search"
                  placeholder="Search records"
                  v-model="searchQuery"
                  aria-controls="datatables"
                ></el-input>
              </base-input>
            </div>
            <el-table
              :data="queriedData"
              :header-cell-style="{
                background: 'transparent',
                border: 'none',
                borderBottom: '0.5px solid #3d3f51',
              }"
              :cell-style="{
                border: 'none',
                borderBottom: '0.5px solid #3d3f51',
              }"
            >
              <el-table-column
                :min-width="150"
                prop="assetNo"
                label="Asset No"
              ></el-table-column>
              <el-table-column
                :min-width="150"
                prop="assetDesc"
                label="Asset Description"
              ></el-table-column>
              <el-table-column
                :min-width="150"
                prop="capitalizedDate"
                label="Capitalized Date"
              ></el-table-column>
              <el-table-column
                :min-width="150"
                prop="costCentre"
                label="Cost Centre"
              ></el-table-column>
              <!-- <el-table-column :min-width="150" prop="condition" label="Condition"></el-table-column>
              <el-table-column :min-width="150" prop="location" label="Location"></el-table-column> -->
              <el-table-column
                :min-width="150"
                prop="ownedBy"
                label="Owned By"
              ></el-table-column>
              <!-- <el-table-column :min-width="150" prop="lastPPMDate" label="Last PPM Date"></el-table-column>
              <el-table-column :min-width="150" prop="etdDate" label="ETD Date"></el-table-column> -->
              <el-table-column :min-width="135" align="right" label="Actions">
                <div slot-scope="props">
                  <el-tooltip content="Edit" placement="bottom" effect="light">
                    <base-button
                      @click="modals = true"
                      @click.native="getRow(props.$index, props.row)"
                      class="edit btn-link"
                      type="info"
                      size="sm"
                      icon
                    >
                      <i class="tim-icons icon-pencil"></i>
                    </base-button>
                  </el-tooltip>
                  <el-tooltip
                    content="Delete"
                    placement="bottom"
                    effect="light"
                  >
                    <base-button
                      @click.native="handleDelete(props.$index, props.row)"
                      class="remove btn-link"
                      type="danger"
                      size="sm"
                      icon
                    >
                      <i class="tim-icons icon-simple-remove"></i>
                    </base-button>
                  </el-tooltip>
                </div>
              </el-table-column>
            </el-table>
          </div>
          <div class="d-flex justify-content-center spinner" v-if="load">
            <circle-8></circle-8>
          </div>
          <div
            slot="footer"
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <div class>
              <p class="card-category">
                Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
              </p>
            </div>
            <base-pagination
              class="pagination-no-border"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="total"
            ></base-pagination>
          </div>
        </card>
      </div>
    </div>
  </div>
</template>
<script>
import LineChart from "src/components/Charts/LineChart";
import config from "@/config";
import * as chartConfigs from "@/components/Charts/config";
import { BaseProgress, Modal, BasePagination } from "src/components";
import {
  Table,
  TableColumn,
  Select,
  Option,
  TimeSelect,
  DatePicker,
} from "element-ui";
import Fuse from "fuse.js";
import moment from "moment";
import swal from "sweetalert2";
import { ImageUpload } from "src/components";
import { Circle8 } from "vue-loading-spinner";

export default {
  components: {
    ImageUpload,
    Modal,
    LineChart,
    BaseProgress,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [DatePicker.name]: DatePicker,
    [TimeSelect.name]: TimeSelect,
    BasePagination,
    Circle8,
  },
  data() {
    return {
      load: false,
      image: "",
      assetNo: "",
      assetDesc: "",
      capitalizedDate: "",
      costCentre: "",
      ownedBy: "",
      // modal
      modals: false,
      // modals2: false,
      selects: {
        costcentre: [],
        ownedby: [],
      },
      EmpID: "",
      searchQuery: "",
      propsToSearch: ["assetNo", "costCentre", "ownedBy"],
      tableData: [],
      searchedData: [],
      fuseSearch: null,
      currentRow: "",
      pagination: {
        perPage: 5,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0,
      },
      ownedby: [],
      costcenter: [],
      imagebase64: "",
      images: {
        regular: null,
      },
    };
  },
  mounted() {
    // Fuse search initialization.
    this.fuseSearch = new Fuse(this.tableData, {
      keys: ["assetNo", "costCentre", "ownedBy"],
      threshold: 0.3,
    });
  },
  computed: {
    /***
     * Returns a page from the searched data or the whole data. Search is performed in the watch section below
     */
    queriedData() {
      let result = this.tableData;
      if (this.searchedData.length > 0) {
        result = this.searchedData;
      }
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.searchedData.length > 0
        ? this.searchedData.length
        : this.tableData.length;
    },
  },
  methods: {
    getAsset() {
      this.load = true;
      console.log("hai");
      this.tableData = [];
      this.searchedData = [];
      //call
      this.$http.get(":9996/api/v1/manage/asset").then((res) => {
        if (!res.error) {
          let response = res.message;
          console.log(response);
          for (var i = 0; i < response.length; i++) {
            let obj = {
              assetNo: response[i].AssetNo,
              assetDesc: response[i].AssetDesc,
              capitalizedDate: response[i].CapitalizedDate,
              costCentre: response[i].CostCenterName,
              ownedBy: response[i].OwnedByName,
            };
            this.tableData.push(obj);
            this.searchedData.push(obj);
            this.load = false;
          }
        } else {
          swal({
            title: "Opps! something went wrong",
            text: res.message,
            type: "warning",
            confirmButtonClass: "btn btn-success btn-fill",
            confirmButtonText: "Okay",
            buttonsStyling: false,
          });
          this.load = false;
        }
      });
    },
    getRow(index, row) {
      console.log(index);
      console.log(row);
      this.assetNo = row.assetNo;
      this.assetDesc = row.assetDesc;
      this.capitalizedDate = row.capitalizedDate;
      this.costCentre = row.costCentre;
      this.ownedBy = row.ownedBy;
    },
    handleDelete(index, row) {
      console.log(index);
      console.log(row);
      swal({
        title: "Are you sure?",
        text: `You won't be able to revert this!`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-success btn-fill",
        cancelButtonClass: "btn btn-danger btn-fill",
        confirmButtonText: "Yes, delete it!",
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.deleteRow(row);
          swal({
            title: "Deleted!",
            text: `You deleted ${row.assetNo}`,
            type: "success",
            confirmButtonClass: "btn btn-success btn-fill",
            buttonsStyling: false,
          });
          this.getAsset();
        }
      });
    },
    deleteRow(row) {
      console.log(row.assetNo);
      this.$http
        .delete(":9996/api/v1/manage/asset/" + row.assetNo)
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            console.log(response);
            this.getAsset();
          }
        });
    },
    getCostCentre() {
      this.selects.costcentre = [];
      this.$http.get(":9996/api/v1/manage/cost").then((res) => {
        if (!res.error) {
          let response = res.message;
          console.log(response);
          for (var i = 0; i < response.length; i++) {
            let obj = {
              label: response[i].CostCenterName,
              value: response[i].CostCenterName,
            };
            this.selects.costcentre.push(obj);

            //   find id when submit later
            let temp = {
              CostCenterName: response[i].CostCenterName,
              CostCenterID: response[i].CostCenterID,
            };
            this.costcenter.push(temp);
          }
          console.log(this.selects.costcentre);
        }
      });
    },
    onImageChange(file) {
      this.images.regular = file;
      console.log(this.image);
      console.log(file.name);
      this.img = file.name;
      console.log(file);
      // this.imagebase64 = file
      const reader = new FileReader();

      reader.onload = (event) => {
        console.log(event);
        file = event.target.result;
        console.log(file);

        file.replace(event.target.result);
        console.log(file);
        this.imagebase64 = file;
      };
      reader.readAsDataURL(file);

      console.log(this.imagebase64);
    },
    getOwnedBy() {
      this.selects.ownedby = [];
      this.$http.get(":9996/api/v1/manage/owner").then((res) => {
        if (!res.error) {
          let response = res.message;
          console.log(response);
          for (var i = 0; i < response.length; i++) {
            let obj = {
              label: response[i].OwnedByName,
              value: response[i].OwnedByName,
            };
            this.selects.ownedby.push(obj);

            //   find id when submit later
            let temp = {
              OwnedByName: response[i].OwnedByName,
              OwnedByID: response[i].OwnedByID,
            };
            this.ownedby.push(temp);
          }
        }
      });
    },
    submit() {
      this.load = true;
      console.log(
        this.assetNo,
        this.assetDesc,
        moment(this.capitalizedDate).format("YYYY-MM-DD"),
        this.costCentre,
        this.ownedBy
      );
      // find costcenter ID
      let costCenterID = "";
      for (var i = 0; i < this.costcenter.length; i++) {
        if (this.costCentre == this.costcenter[i].CostCenterName) {
          costCenterID = this.costcenter[i].CostCenterID;
        }
      }

      // find ownedby ID
      let ownedbyID = "";
      for (var i = 0; i < this.ownedby.length; i++) {
        if (this.ownedBy == this.ownedby[i].OwnedByName) {
          ownedbyID = this.ownedby[i].OwnedByID;
        }
      }

      // process the image
      console.log(this.imagebase64);
      let img = this.imagebase64.split(",")[1];
      console.log(this.imagebase64.substr(23));

      let payload = {
        AssetNo: this.assetNo,
        AssetDesc: this.assetDesc,
        CapitalizedDate: moment(this.capitalizedDate).format("YYYY-MM-DD"),
        CostCenterID: costCenterID,
        OwnedByID: ownedbyID,
        ImagePath: img,
      };
      console.log(payload);

      // send
      this.$http
        .put(":9996/api/v1/manage/asset/" + this.assetNo, payload)
        .then((res) => {
          if (!res.error) {
            swal({
              title: "Successful!",
              text: res.message,
              type: "success",
              confirmButtonClass: "btn btn-success btn-fill",
              confirmButtonText: "Okay",
              buttonsStyling: false,
            }).then((result) => {
              if (result.value) {
                this.$router.go();
              }
            });
            this.modals = false;
            this.assetNo = "";
            this.assetDesc = "";
            this.capitalizedDate = "";
            this.costCentre = "";
            this.ownedBy = "";
            this.load = false;
          } else {
            swal({
              title: "Data Error!",
              text: `${res.message}`,
              type: "warning",
              confirmButtonClass: "btn btn-success btn-fill",
              confirmButtonText: "Okay",
              buttonsStyling: false,
            });
            this.load = false;
          }
        });
    },
  },
  created() {
    this.getCostCentre();
    this.getOwnedBy();
    this.getAsset();
  },
  watch: {
    /**
     * Searches through the table data by a given query.
     * NOTE: If you have a lot of data, it's recommended to do the search on the Server Side and only display the results here.
     * @param value of the query
     */
    searchQuery(value) {
      let result = this.tableData;
      if (value !== "") {
        result = this.fuseSearch.search(this.searchQuery);
      }
      this.searchedData = result;
    },
  },
};
</script>
<style lang="scss" scoped>
.footer-font {
  font-size: 105%;
}
.tab {
  margin-left: 1%;
  margin-right: 1%;
}
.test {
  width: 800px;
}
.dialog {
  margin-left: 30%;
}

.huraian {
  width: 100%;
  height: 150px;
  padding: 12px 20px;
  box-sizing: border-box;
  border: 2px solid #ccc;
  border-radius: 4px;
  background-color: #f8f8f8;
  font-size: 14px;
  resize: none;
}
</style>
